import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSessionAuth } from "@/app/_utils/sessionClient";
import FullPageLoader from "@/app/admin/_common/FullPageLoader";

export default function RequireAuth() {
  const { session, status } = useSessionAuth();
  const location = useLocation();

  // auth/me/ decides, so wait for it rather than bouncing to /login on first paint.
  if (status === "loading" && !session) {
    return <FullPageLoader />;
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
